import React, { useMemo } from "react";
import { Card } from "antd";
import { formatMoney, formatDateTime } from "../../../utils/formatUtils";

export default function TransferSummarySection({
  isTransfer,
  amount,
  senderRate,
  receiverRate,
  fee = 0,
  description,
  senderCurrency,
  receiverCurrency,
  transactionDate,
}) {

  const expectedReceiver = (() => {
    const amt = Number(amount);
    const sRate = Number(senderRate);
    const rRate = Number(receiverRate);

    if (
      !Number.isFinite(amt) ||
      !Number.isFinite(sRate) ||
      !Number.isFinite(rRate) ||
      rRate === 0
    ) {
      return 0;
    }

    return (amt * sRate) / rRate;
  })();

  const expectedSenderTotal = Number(amount || 0);

  const senderCurrencyCode =
    typeof senderCurrency === "string"
      ? senderCurrency
      : senderCurrency?.code || senderCurrency?.name || "";

  const receiverCurrencyCode =
    typeof receiverCurrency === "string"
      ? receiverCurrency
      : receiverCurrency?.code || receiverCurrency?.name || "";

  const expectedSenderWithFee = Number(amount || 0) + Number(fee || 0);

  if (!isTransfer && !description) return null;

  return (
    <Card className="mt-5 rounded-2xl border border-slate-200 shadow-sm">
      <div className="mb-4 text-base font-semibold text-slate-800">
        Шилжүүлгийн хураангуй
      </div>

      <div className="grid grid-cols-1 gap-10 md:grid-cols-2 rounded-xl bg-slate-50 p-4">
        <div className="md:pr-6 md:border-r md:border-slate-200">
          <div className="flex justify-between">
            <span className="text-slate-500">Илгээх дүн</span>
            <span className="font-medium text-red-600">
              - {formatMoney(expectedSenderTotal, senderCurrencyCode)}
            </span>
          </div>
          <div className="flex justify-between">
            <span className="text-slate-500">Илгээх ханш</span>
            <span className="font-medium">{senderRate || "-"}</span>
          </div>
          <div className="flex justify-between">
            <span className="text-slate-500">Шимтгэл</span>
            <span className="font-medium">
              - {formatMoney(fee || 0, senderCurrencyCode)}
            </span>
          </div>
          <div className="flex justify-between">
            <span className="text-slate-500">Нийт зарлага</span>
            <span className="font-medium text-red-600">
              - {formatMoney(expectedSenderWithFee, senderCurrencyCode)}
            </span>
          </div>
        </div>
        <div className="md:pl-6">
          <div className="flex justify-between">
            <span className="text-slate-500">Хүлээн авах дүн</span>
            <span className="font-medium text-emerald-600">
              + {formatMoney(expectedReceiver, receiverCurrencyCode)}
            </span>
          </div>
          <div className="flex justify-between">
            <span className="text-slate-500">Хүлээн авах ханш</span>
            <span className="font-medium">{receiverRate || "-"}</span>
          </div>
        </div>
      </div>
      <div className="rounded-xl bg-slate-50 p-4">
          <div className="space-y-2 text-sm">
            <div className="flex justify-between gap-4">
              <span className="text-slate-500">Description</span>
              <span className="text-right font-medium text-slate-700">
                {description?.trim() || "-"}
              </span>
            </div>
            <div className="flex justify-between gap-4">
              <span className="text-slate-500">Date time</span>
              <span className="text-right font-medium text-slate-700">
                {formatDateTime(transactionDate) || "-"}
              </span>
            </div>
          </div>
        </div>
    </Card>
  );
}